import React from "react";
export interface IState {
	currentDataset: DatasetDTO;
	currentOrganization: OrganizationDTO;
	updateCurrentDataset: (dataset: DatasetDTO) => void;
	updateCurrentOrganization: (org: any) => void;
}
const initialState: IState = {
	currentDataset: {},
	// tslint:disable-next-line:no-empty
	updateCurrentDataset: (dataset: DatasetDTO) => {},
	currentOrganization: { name: "name from context", id: undefined },
	// tslint:disable-next-line:no-empty
	updateCurrentOrganization: () => {},
};

const DatasetContext = React.createContext(initialState);
export default DatasetContext;
